/**
 * locale — self-contained chrome strings for the shared VN render layer.
 *
 * PlayerStage / primitives / cg-media render a handful of user-facing strings
 * (missing-asset placeholders, the tap hint, the choice prompt, the continue
 * button, the empty-phone line, the cg fallback label). When this renderer
 * lived inside ls-preview it borrowed those from the preview webview's big
 * `voice-i18n` dictionary; now that the renderer is shared across ls-preview,
 * ls-studio (F Studio monitor) and lunaria-web it owns its OWN tiny dictionary
 * so it has zero dependency on any one consumer's i18n surface.
 *
 * `StageLang` is the two-locale union every consumer already speaks
 * (ls-preview's `PreviewLanguage`, shared's `AppLocale`, lunaria-web's locale
 * are all `"en" | "zh-CN"`), so a consumer passes its own locale value straight
 * through. A missing key falls back to the English string, then to the key.
 */
const STRINGS = {
    en: {
        "player.bgMissing": "Background not rendered",
        "player.spriteMissing": "Sprite not rendered",
        "player.tapToContinue": "Tap to continue",
        "player.choicePrompt": "Make a choice",
        "player.phoneEmpty": "(Conversation not started)",
        "player.continue": "Continue",
        "player.cgFallback": "CG",
    },
    "zh-CN": {
        "player.bgMissing": "背景未渲染",
        "player.spriteMissing": "立绘未渲染",
        "player.tapToContinue": "点击继续",
        "player.choicePrompt": "做个选择",
        "player.phoneEmpty": "（对话未开始）",
        "player.continue": "继续",
        "player.cgFallback": "CG",
    },
};
export function t(language, key) {
    const dict = STRINGS[language] ?? STRINGS.en;
    return dict[key] ?? STRINGS.en[key] ?? key;
}
